import { useCustomerLabel } from '../../api/directory.ts';
import { cx } from '../../ui/cx.ts';

const EMPTY_FALLBACK = '—';

export function CustomerRef({
  orgId,
  accountId,
  className,
  fallback,
}: {
  readonly orgId?: string | null;
  readonly accountId?: string | null;
  readonly className?: string;
  readonly fallback?: string;
}): JSX.Element {
  const labels = useCustomerLabel();
  const resolvedOrgId = orgId === undefined || orgId === null || orgId.length === 0 ? null : orgId;
  const resolvedAccountId =
    accountId === undefined || accountId === null || accountId.length === 0 ? null : accountId;
  const id = resolvedOrgId ?? resolvedAccountId;
  if (id === null) {
    return <span>{fallback ?? EMPTY_FALLBACK}</span>;
  }
  const label = resolvedOrgId !== null ? labels.byOrg(resolvedOrgId) : labels.byAccount(resolvedAccountId);
  return (
    <span
      className={cx('font-mono', className)}
      title={id}
      data-customer-ref={id}
      data-customer-ref-kind={orgId !== undefined && orgId !== null ? 'org' : 'account'}
    >
      {label}
    </span>
  );
}
